import { render, staticRenderFns } from "./EprescribeItemPreview.vue?vue&type=template&id=0f3edfa2"
import script from "./EprescribeItemPreview.vue?vue&type=script&lang=js"
export * from "./EprescribeItemPreview.vue?vue&type=script&lang=js"
import style0 from "./EprescribeItemPreview.vue?vue&type=style&index=0&id=0f3edfa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports